import React, { Component } from 'react';
import FormicaToggleSwitch from '../../custom/FormicaToggleSwitch';
import LanguageUtil from '../../../util/LanguageUtil';

class WatchlistExactMatchSwitch extends Component<Props> {
  public render() {
    const { value } = this.props;
    return (
      <div className={'flex items-center gap-x-2'}>
        <span className={'text-md text-normal text-[#4F4F4F]'}>
          {LanguageUtil.get({ id: 'common.label.exactMatch', defaultMessage: 'Exact Match' })}
        </span>
        <div className={'flex items-center scale-100 2xl:scale-110'}>
          <FormicaToggleSwitch value={value} onChange={this.onToggle} />
        </div>
      </div>
    );
  }

  private onToggle = (): void => {
    this.props.onChange(!this.props.value);
  };
}

interface Props {
  value: boolean;
  onChange: (exactMatch: boolean) => void;
}

export default WatchlistExactMatchSwitch;
